import { useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgUrl } from "@/lib/api";

export const PackGallery = ({ images, name }) => {
  const [open, setOpen] = useState(null);
  if (!images.length)
    return (
      <div className="rounded-[3px] border border-dashed border-[#163D43] p-12 text-center text-teal-200" data-testid="pack-gallery-empty">
        As prévias desta versão serão publicadas em breve.
      </div>
    );
  return (
    <>
      <div className="columns-1 gap-5 sm:columns-2 lg:columns-3" data-testid="pack-gallery">
        {images.map((src, i) => (
          <motion.button
            key={src + i}
            onClick={() => setOpen(src)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
            className="group mb-5 block w-full overflow-hidden rounded-[3px] border border-[#163D43] bg-[#0B2326]"
            data-testid={`pack-gallery-item-${i}`}
          >
            <img src={imgUrl(src)} alt={`${name} — prévia ${i + 1}`} className="w-full transition-transform duration-700 group-hover:scale-105" />
          </motion.button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-4xl border-[#163D43] bg-[#041214] p-2" data-testid="pack-gallery-lightbox">
          <DialogTitle className="sr-only">{name}</DialogTitle>
          {open && <img src={imgUrl(open)} alt={name} className="max-h-[85vh] w-full object-contain" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
